import React from "react";

const CloseButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      aria-label="Close"
      className="relative w-9 h-9 flex items-center justify-center rounded-full
                 border border-gray-200 hover:border-primaryFadedColor
                 transition-all duration-300 group"
    >
      <span
        className="absolute h-[2px] w-5 bg-primaryNavyTextColor rounded-full
                   rotate-45 transition-transform duration-300
                   group-hover:rotate-[135deg] group-hover:scale-110"
      />
      <span
        className="absolute h-[2px] w-5 bg-primaryNavyTextColor rounded-full
                   -rotate-45 transition-transform duration-300
                   group-hover:-rotate-[135deg] group-hover:scale-110"
      />
    </button>
  );
};

export default CloseButton;
